import { EnumModuleType } from '@/src/types/common/module';
import React from 'react';
import WhiteBackgroundTooltip, {
  EnumPosition,
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { MODULE_MAP } from 'src/constrains/ModuleCart';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const AddModule = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, onClick } = props;
  const moduleList1 = [
    {
      type: EnumModuleType.ResponsiveSubscription,
      onClick: () => {
        onClick(EnumModuleType.ResponsiveSubscription);
      },
    },
    {
      type: EnumModuleType.ResponsivePoster,
      onClick: () => {
        onClick(EnumModuleType.ResponsivePoster);
      },
    },

    {
      type: EnumModuleType.ResponsiveImageCarousel,
      onClick: () => {
        onClick(EnumModuleType.ResponsiveImageCarousel);
      },
    },

    //  //
    //
  ];

  const moduleList2 = [
    {
      type: EnumModuleType.ResponsiveContentGrid,
      onClick: () => {
        onClick(EnumModuleType.ResponsiveContentGrid);
      },
    },
    {
      type: EnumModuleType.ResponsiveText,
      onClick: () => {
        onClick(EnumModuleType.ResponsiveText);
      },
    },
    {
      type: EnumModuleType.ResponsivePosterTab,
      onClick: () => {
        onClick(EnumModuleType.ResponsivePosterTab);
      },
    },

    //  //
    //
  ];
  const moduleList3 = [
    {
      type: EnumModuleType.ResponsiveIframe,
      onClick: () => {
        onClick(EnumModuleType.ResponsiveIframe);
      },
    },
  ];

  return (
    <React.Fragment>
      {disabled ? (
        <div className={`${css.btnClassName} ${css.addBtnDisabledColor}`}>
          + {getI18n('salesChannelContent.index.addModule')}
        </div>
      ) : (
        <WhiteBackgroundTooltip
          title={
            <TooltipContainer>
              <TooltipTitle>{getI18n('general.modules')}</TooltipTitle>
              <TooltipContent style={{ display: 'flex' }}>
                {moduleList1.map((i) => {
                  return (
                    <div key={i.type} className={css.image} onClick={i.onClick}>
                      <div className={css.icon}>{MODULE_MAP[i.type].icon}</div>
                      <div className={css.type}>
                        {getI18n(MODULE_MAP[i.type].i18nKey)}
                      </div>
                    </div>
                  );
                })}
              </TooltipContent>
              <TooltipContent style={{ display: 'flex' }}>
                {moduleList2.map((i) => {
                  return (
                    <div key={i.type} className={css.image} onClick={i.onClick}>
                      <div className={css.icon}>{MODULE_MAP[i.type].icon}</div>
                      <div className={css.type}>
                        {getI18n(MODULE_MAP[i.type].i18nKey)}
                      </div>
                    </div>
                  );
                })}
              </TooltipContent>
              <TooltipContent style={{ display: 'flex' }}>
                {moduleList3.map((i) => {
                  return (
                    <div key={i.type} className={css.image} onClick={i.onClick}>
                      <div className={css.icon}>{MODULE_MAP[i.type].icon}</div>
                      <div className={css.type}>
                        {getI18n(MODULE_MAP[i.type].i18nKey)}
                      </div>
                    </div>
                  );
                })}
              </TooltipContent>
            </TooltipContainer>
          }
          placement={EnumPosition.bottom}>
          <div className={css.btnClassName}>
            + {getI18n('salesChannelContent.index.addModule')}
          </div>
        </WhiteBackgroundTooltip>
      )}
    </React.Fragment>
  );
};
export default AddModule;
